export function getCurrentYYYYmmdd() {
	let date = new Date()
	return `${date.getFullYear()}-${addZero(date.getMonth() + 1)}-${addZero(date.getDate())}`
}

export function toYYYYmmdd(longTime) {
	if (typeof longTime === 'string') {
		longTime = parseInt(longTime)
	}
	let dateTemp = new Date(longTime)
	return `${dateTemp.getFullYear()}-${addZero(dateTemp.getMonth() + 1)}-${addZero(dateTemp.getDate())}`
}

export function toYYYYmmddFullDate(longTime) {
	if (typeof longTime === 'string') {
		longTime = parseInt(longTime)
	}
	let dateTemp = new Date(longTime)
	let hh = addZero(dateTemp.getHours())
	let mf = addZero(dateTemp.getMinutes())
	let ss = addZero(dateTemp.getSeconds())
	return `${dateTemp.getFullYear()}-${addZero(dateTemp.getMonth() + 1)}-${addZero(dateTemp.getDate())} ${hh}:${mf}:${ss}`
}

export function currentFullData() {
	let timeTemp = currentYYYYmmdd()
	let day = new Date()
	let hh = addZero(day.getHours())
	let mf = addZero(day.getMinutes())
	let ss = addZero(day.getSeconds())
	return timeTemp + ' ' + hh + ':' + mf + ':' + ss
}

export function currentYYYYmmdd() {
	let date = new Date()
	return `${date.getFullYear()}-${addZero(date.getMonth() + 1)}-${addZero(date.getDate())}`
}

export function addZero(tempData) {
	return tempData < 10 ? '0' + tempData : tempData
}

// 从生效日期date向后num个自然月
export function getInsureEndTime(date, term) {
	//判断是否带单位
	let termUnit = 'M'
	if (term.includes('_')) {
		let [one, two] = term.split('_')
		term = one
		termUnit = two
	}
	term = parseInt(term)
	//毫秒值
	let newDate = null
	//单位为天
	if (termUnit === 'D') {
		newDate = date.getTime() + (term - 1) * 24 * 60 * 60 * 1000
	} else {
		let year = date.getFullYear()
		let month = date.getMonth()
		let day = date.getDate()

		year = year + parseInt((month + term) / 12)
		month = (month + term) % 12
		let maxDayCount = new Date(year, month + 1, 0).getDate()
		if (day > maxDayCount) {
			day = maxDayCount
		}
		newDate = new Date(year, month, day - 1).getTime()
	}
	return toYYYYmmdd(newDate)
}
